import React, { useEffect, useState, useRef } from 'react'
import Card from '../../../components/Card'
import { Row, Col, Alert, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { GoogleMap, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";
import { userSignal } from '../../../signal/userSignal';
import { toast } from 'react-toastify';
import StartMarker from '../../../assets/images/icons/start-marker.svg'
import avatar1 from "../../../assets/images/avatars/01.png"
import { allUsersSignal } from '../../../signal/allUsersSignal';
import { googleMapKey } from '../../../constants/googleMapKey';
import { myGrpsSignal } from '../../../signal/myGrpsSIgnals';
import { WS_URL } from '../../../constants/urls';

const Google = (props) => {
    const [locations, setLocations] = useState({})
    const [userDetails, setUserDetails] = useState([])
    const [search, setSearch] = useState([])
    const [center, setCenter] = useState({ lat: -33.847927, lng: 150.6517938 })
    const [selectedUser, setSelectedUser] = useState(null)
    // take location from ip address


    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: googleMapKey,
    });

    // track if component is still mounted to avoid showing toasts after unmount
    const isMountedRef = useRef(true);
    useEffect(() => {
        return () => { isMountedRef.current = false };
    }, []);

    const resetData = () => {
        setLocations({})
        setUserDetails([])
        try {
            window.localStorage.removeItem("locations")
            window.localStorage.removeItem("userDetails")
        } catch (err) {
            console.log(err)
        }
    }

    // Live Tracking WebSocket
    useEffect(() => {
        let ws;
        let reconnectTimeout;
        let flag = false;
        let manualClose = false; // track if close was triggered by cleanup/navigation

        function connect() {
            ws = new window.WebSocket(WS_URL);

            ws.onopen = () => {
                ws.send(JSON.stringify({
                    type: "register",
                    connectionType: "liveTracking",
                    userId: userSignal.value?.user?.id,
                    orgId: userSignal.value?.user?.organisation,
                    name: userSignal.value?.user?.name,
                    userType: userSignal.value?.user?.userType,
                    profileUrl: userSignal.value?.user?.profileURL
                }));
            };

            ws.onmessage = (event) => {
                try {
                    const response = JSON.parse(event.data);
                    if (!response.locations) return;

                    let userId = response.userId;
                    if (!allUsersSignal.value[userId] || !myGrpsSignal.value.includes(allUsersSignal.value[userId]?.group)) {
                        return;
                    }

                    let locationslist = response.locations;
                    let charging = response.charging;
                    let distance = response.distance;

                    let newLocations = [];
                    for (let i = 0; i < locationslist?.length; i += 2) {
                        newLocations.push({ lat: parseFloat(locationslist[i]), lng: parseFloat(locationslist[i + 1]) });
                    }

                    let locationsFromStorage = JSON.parse(window.localStorage.getItem("locations")) || {};
                    let existingLocations = locationsFromStorage[userId] || [];
                    let userLocations = existingLocations.concat(newLocations);
                    let test = locationsFromStorage || {};
                    test[userId] = userLocations;
                    window.localStorage.setItem("locations", JSON.stringify(test));

                    let temp = JSON.parse(window.localStorage.getItem("userDetails")) || [];
                    let index = temp.findIndex((value) => value.userId === userId);
                    if (index !== -1) {
                        temp[index] = { ...temp[index], charging, distance };
                    } else {
                        temp.push({ userId, charging, distance });
                    }
                    window.localStorage.setItem("userDetails", JSON.stringify(temp));
                    if (!flag) {
                        setLocations(test);
                        setUserDetails(temp);
                        flag = true;
                    }
                } catch (err) {
                    console.log("WS message error", err);
                }
            };

            ws.onclose = (event) => {
                // detect intentional close (cleanup) via manualClose flag or explicit reason
                const intentional = manualClose || (event && event.reason === 'component_unmount');
                if (intentional) {
                    flag = false;
                    return;
                }

                // Consider it a real disconnect only when the close was unclean or had a non-1000 code
                const wasClean = event && typeof event.wasClean === 'boolean' ? event.wasClean : false;
                const code = event && typeof event.code === 'number' ? event.code : undefined;
                const abnormal = !wasClean || (code !== undefined && code !== 1000);

                if (abnormal) {
                    if (isMountedRef.current) {
                        toast.error("You are disconnected, Please refresh!");
                    }
                    resetData();
                    flag = false;
                    reconnectTimeout = setTimeout(connect, 3000);
                } else {
                    // clean/expected close: don't reset app state or show toast
                    flag = false;
                }
            };

            ws.onerror = (err) => {
                console.log("WebSocket error", err);
                ws.close();
            };
        }

        connect();

        return () => {
            // indicate this close is intentional to avoid showing a disconnect toast
            manualClose = true;
            if (ws) ws.close(1000, 'component_unmount');
            if (reconnectTimeout) clearTimeout(reconnectTimeout);
        };
    }, [])

    // Status Tracking WebSocket
    useEffect(() => {
        let ws;
        let reconnectTimeout;
        let flag = false;
        let manualClose = false; // track if close was triggered by cleanup/navigation

        function connect() {
            ws = new window.WebSocket(WS_URL);

            ws.onopen = () => {
                ws.send(JSON.stringify({
                    type: "register",
                    connectionType: "statusTracking",
                    userId: userSignal.value?.user?.id,
                    orgId: userSignal.value?.user?.organisation,
                    name: userSignal.value?.user?.name,
                    userType: userSignal.value?.user?.userType,
                    profileUrl: userSignal.value?.user?.profileURL
                }));
            };

            ws.onmessage = (event) => {
                try {
                    const response = JSON.parse(event.data);
                    if (!response.status) return;

                    let userId = response.userId;
                    if (!allUsersSignal.value[userId] || !myGrpsSignal.value.includes(allUsersSignal.value[userId]?.group)) {
                        return;
                    }
                    let orgId = response.orgId;
                    let name = response.name;
                    let userType = response.userType;
                    let profileUrl = response.profileUrl || avatar1;
                    let status = response.status;
                    let temp = JSON.parse(window.localStorage.getItem("userDetails")) || [];
                    let index = temp.findIndex((value) => value.userId === userId);
                    if (index !== -1) {
                        temp[index] = { ...temp[index], userId, orgId, name, userType, profileUrl, status, color: `#${Math.floor(Math.random() * 16777215).toString(16)}` };
                    } else {
                        temp.push({ userId, orgId, name, userType, profileUrl, status });
                    }
                    if (!flag) {
                        setUserDetails(temp);
                        if (selectedUser === null) {
                            setSelectedUser({
                                userId, orgId, name, userType, profileUrl, status, color: `#${Math.floor(Math.random() * 16777215).toString(16)}`
                            });
                        }
                        flag = true;
                    }
                    window.localStorage.setItem("userDetails", JSON.stringify(temp));
                } catch (err) {
                    console.log("WS status message error", err);
                }
            };

            ws.onclose = (event) => {
                // detect intentional close (cleanup) via manualClose flag or explicit reason
                const intentional = manualClose || (event && event.reason === 'component_unmount');
                if (intentional) {
                    flag = false;
                    return;
                }

                const wasClean = event && typeof event.wasClean === 'boolean' ? event.wasClean : false;
                const code = event && typeof event.code === 'number' ? event.code : undefined;
                const abnormal = !wasClean || (code !== undefined && code !== 1000);

                if (abnormal) {
                    if (isMountedRef.current) {
                        toast.error("You are disconnected, Please refresh!");
                    }
                    flag = false;
                    reconnectTimeout = setTimeout(connect, 3000);
                } else {
                    // clean/expected close: don't notify or reconnect
                    flag = false;
                }
            };

            ws.onerror = (err) => {
                console.log("WebSocket error", err);
                ws.close();
            };
        }

        connect();

        return () => {
            // indicate this close is intentional to avoid showing a disconnect toast
            manualClose = true;
            if (ws) ws.close(1000, 'component_unmount');
            if (reconnectTimeout) clearTimeout(reconnectTimeout);
        };
    }, [])

    // Poll localStorage for updates every 10s
    useEffect(() => {
        try {
            window.localStorage.removeItem("locations")
            window.localStorage.removeItem("userDetails")
        } catch (err) {
            console.log(err)
        }

        let interval = setInterval(() => {
            let temp = JSON.parse(window.localStorage.getItem("userDetails")) || []
            setUserDetails(temp)
            let locationsFromStorage = JSON.parse(window.localStorage.getItem("locations")) || {}
            setLocations(locationsFromStorage)
        }, 10000)

        return () => {
            clearInterval(interval)
            try {
                window.localStorage.removeItem("locations")
                window.localStorage.removeItem("userDetails")
            } catch (err) {
                console.log(err)
            }
        }
    }, [])

    // Get user location from IP
    useEffect(() => {
        fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(response => {
                setCenter({ lat: response.latitude, lng: response.longitude })
            })
            .catch(err => console.log(err));
    }, [])

    return (
        <div style={{ width: "100%", height: "90vh" }}>
            {isLoaded &&
                <GoogleMap
                    mapContainerStyle={{ width: "100%", height: "100%" }}
                    zoom={17}
                    mapContainerClassName="map-container"
                    center={center}
                    options={{
                        streetViewControl: false,
                        zoomControl: false,
                        mapTypeControl: true,
                        fullscreenControlOptions: {
                            position: window.google.maps.ControlPosition.LEFT_TOP,
                        },
                    }}
                >
                    {selectedUser &&
                        <div key={selectedUser?.userId}>
                            {locations[selectedUser?.userId]?.length > 0 && <Marker position={{ lat: locations[selectedUser?.userId]?.length > 0 ? locations[selectedUser?.userId][0]?.lat : 0, lng: locations[selectedUser?.userId]?.length > 0 ? locations[selectedUser?.userId][0]?.lng : 0 }} icon={{ url: StartMarker, scaledSize: new window.google.maps.Size(20, 20) }} shape={"rounded"} />}
                            {locations[selectedUser?.userId]?.length > 0 && <Marker position={{ lat: locations[selectedUser?.userId][locations[selectedUser?.userId]?.length - 1]?.lat, lng: locations[selectedUser?.userId][locations[selectedUser?.userId]?.length - 1]?.lng }} title={selectedUser?.name} icon={{
                                url: selectedUser?.profileUrl,
                                scaledSize: new window.google.maps.Size(30, 30)
                            }} />
                            }
                            <Polyline path={locations[selectedUser?.userId]}
                                options={{
                                    geodesic: true,
                                    strokeColor: selectedUser?.color,
                                    strokeOpacity: 1,
                                    strokeWeight: 6
                                }}
                            />
                        </div>
                    }

                    <div style={{ width: "200px", height: "100%", overflowY: 'scroll', background: "linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(0,0,0,0.75))", position: "relative", display: "flex", float: "right", flexDirection: "column", rowGap: "1rem", paddingTop: "0.5rem" }}>
                        <input style={{ width: "90%", borderRadius: "9999px", padding: "0.2rem", paddingLeft: "0.8rem", margin: "0px auto", outline: "none" }} type='search' placeholder='search...' value={search} onChange={(e) => setSearch(e.target.value)}></input>

                        {userDetails?.length === 0 && <Alert variant="danger" style={{ width: "90%", margin: "0px auto" }}>No user on field</Alert>}
                        {userDetails.map((val, i) => {
                            if (search === "" || (val?.name && search !== "" && val?.name.toString().toLowerCase().includes(search.toString().toLowerCase()))) {
                                return (
                                    <div key={val?.userId} style={{ opacity: val?.status === "connected" ? 1 : 0.5, width: "100%" }} className='py-1 shadow'>
                                        <div style={{ display: "flex", width: "90%", alignItems: "center", columnGap: "0.7rem", paddingLeft: "0.7rem", cursor: "pointer" }} onClick={() => {
                                            if (locations[val?.userId]?.length > 0) {
                                                setCenter(locations[val?.userId][locations[val?.userId]?.length - 1])
                                                setSelectedUser(val)
                                            }
                                        }}>

                                            <img src={val.profileUrl} style={{ width: "25px", height: "25px", borderRadius: "50%", border: `2px solid ${val?.color}` }} />
                                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", fontSize: "12px", color: 'white' }}>
                                                <OverlayTrigger placement='top' overlay={<Tooltip style={{ position: "fixed" }}>{val?.name?.toString()}</Tooltip>}>
                                                    <span>{val?.name?.toString()?.length > 12 ? val?.name?.toString().slice(0, 12) + "..." : val?.name?.toString()} ({val?.charging}%)</span>
                                                </OverlayTrigger>
                                                <span style={{ color: "inherit", fontSize: "10px" }}>Distance: <b>{val?.distance ? (parseFloat(val?.distance)).toFixed(2) : "0"} km</b></span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            } else {
                                return <></>
                            }
                        }
                        )}
                    </div>

                </GoogleMap>
            }
        </div>
    )
}

export default Google
